import { FC } from 'react'
import { FileSymlinkIcon } from 'lucide-react'
import { setLessonTab, useAppDispatch, useAppSelector } from '../../../redux'
import { StyledLessonTabs } from '.'

const LessonTabs: FC = () => {
  const dispatch = useAppDispatch()
  const { lesson, tab, loading } = useAppSelector((state) => state.course)

  if (!lesson?.description && !lesson?.additionalFiles?.length && !lesson?.workbook && !loading) {
    return null
  }

  return (
    <StyledLessonTabs>
      <button
        data-active={tab === 'about' || loading}
        disabled={loading}
        onClick={() => dispatch(setLessonTab('about'))}
      >
        About
      </button>
      {!loading && !!lesson?.additionalFiles?.length && (
        <button
          data-active={tab === 'resources'}
          onClick={() => dispatch(setLessonTab('resources'))}
        >
          Resources
          <div className="count">{lesson?.additionalFiles?.length || 0}</div>
        </button>
      )}
      {!loading && !!lesson?.workbook && (
        <button
          data-active={tab === 'workbook'}
          onClick={() => window.open(lesson?.workbook?.fileHttpLink, '_blank')}
        >
          Workbook
          <FileSymlinkIcon />
        </button>
      )}
    </StyledLessonTabs>
  )
}

export default LessonTabs
